import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Space, Tag, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { dviTemplateApi } from '../../services/api/dviApi';
import { DVITemplate } from '../../types/dvi';

export const DVITemplateManager: React.FC = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState<DVITemplate[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    setLoading(true);
    try {
      const list = await dviTemplateApi.list();
      setTemplates(list);
    } catch (err: any) {
      message.error(err?.message ?? 'Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { reload(); }, []);

  const handleArchive = (t: DVITemplate) => {
    Modal.confirm({
      title: `Archive "${t.name}"?`,
      content: "Archived templates can't be picked for new inspections but won't affect existing ones.",
      okText: 'Yes, archive',
      onOk: async () => {
        try {
          await dviTemplateApi.archive(t.id);
          message.success('Archived');
          await reload();
        } catch (err: any) {
          message.error(err?.message ?? 'Failed to archive template');
        }
      },
    });
  };

  const handleSetDefault = async (t: DVITemplate) => {
    try {
      await dviTemplateApi.update(t.id, { isDefault: true });
      message.success(`"${t.name}" is now the default template`);
      await reload();
    } catch (err: any) {
      message.error(err?.message ?? 'Failed to set default template');
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 800, margin: '0 auto' }}>
      <Space style={{ marginBottom: 16, justifyContent: 'space-between', width: '100%' }}>
        <h2 style={{ margin: 0 }}>DVI Templates</h2>
        <Button type="primary" onClick={() => navigate('/owner/settings/dvi-templates/new')}>
          + New Template
        </Button>
      </Space>
      {loading && <div>Loading…</div>}
      <Space direction="vertical" style={{ width: '100%' }}>
        {templates.map(t => (
          <Card key={t.id} size="small">
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Space>
                <span style={{ fontWeight: 600 }}>{t.name}</span>
                {t.is_default ? <Tag color="green">Default</Tag> : null}
              </Space>
              <Space>
                {!t.is_default && (
                  <Button size="small" onClick={() => handleSetDefault(t)}>
                    Make default
                  </Button>
                )}
                <Button size="small" onClick={() =>
                  navigate(`/owner/settings/dvi-templates/${t.id}`)
                }>Edit</Button>
                <Button size="small" danger onClick={() => handleArchive(t)}>
                  Archive
                </Button>
              </Space>
            </Space>
          </Card>
        ))}
        {!loading && templates.length === 0 && (
          <Card><div style={{ textAlign: 'center', color: '#888' }}>
            No templates yet. Click "+ New Template" to create one.
          </div></Card>
        )}
      </Space>
    </div>
  );
};

export default DVITemplateManager;
